// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3987 ? "a3319169" : chunkId) + "." + {"2745":"7556b0a2738c1bde","3987":"ab10b329c6541f1a","3990":"7faabdf86188728e"}[chunkId] + ".js";
};